import React from 'react';
import {
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
} from '@material-ui/core';
import { Description } from '@material-ui/icons';
import { Link } from '@material-ui/icons';
import { Filters } from './../services/Filters';

const _filters = new Filters();

export const NoticeItem = (props) => {

  const date = _filters.startEndDate(props.item.date, props.item.type !== 'kamar' ? props.item.date : props.item.type);
  const header = props.item.header;
  const url = props.item.url;
  return (
    <ListItem
      divider
      key={props.item.id ? props.item.id : props.i}
      button
      onClick={(e) => props.onClick(e, url, props.item.id)}
    > 
      {url ? <ListItemIcon><Link /></ListItemIcon> : <ListItemIcon><Description /></ListItemIcon>}
      <ListItemText>
        {header ? header : date}
        <Typography
          variant='caption'
        >
          {header ? date : null}
        </Typography>
      </ListItemText>
      {url ? _filters.urlIcon(url) : null}
    </ListItem>
  )
}


// WEBPACK FOOTER //
// ./src/components/NoticeItem.js